import { ActionEvent, Controller } from '@hotwired/stimulus'

export default class extends Controller {
  clear (event: ActionEvent): void {
    event.preventDefault()

    const url = new URL(window.location.href)
    const keepParams = new URLSearchParams()
    const blankParams: string[] = event.params.blankParams ?? []

    url.searchParams.forEach((value, key) => {
      if ((key === 'sc[]' || key === 'c[]' || key === 'sc_x') && value !== '') {
        keepParams.append(key, value)
      }
    })

    // An empty value keeps the server from applying its default for the key.
    blankParams.forEach(key => keepParams.append(key, ''))

    url.search = keepParams.toString()
    window.location.href = url.toString()
  }
}
